<script setup lang="ts">
    import type { HTMLAttributes } from 'vue';

    defineOptions({
        inheritAttrs: false,
    });

    interface Props {
        className?: HTMLAttributes['class'];
    }

    defineProps<Props>();
</script>

<template>
    <svg
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="className"
    >
        <g clip-path="url(#clip0_659_23922)">
            <path
                d="M0.762207 0.832031H17.7622V17.832H0.762207V0.832031Z"
                fill="#F3F3F3"
            />
            <path
                d="M1.50146 1.57031H8.89277V8.96162H1.50146V1.57031Z"
                fill="#F35325"
            />
            <path
                d="M9.63184 1.57031H17.0231V8.96162H9.63184V1.57031Z"
                fill="#81BC06"
            />
            <path
                d="M1.50146 9.70117H8.89277V17.0925H1.50146V9.70117Z"
                fill="#05A6F0"
            />
            <path
                d="M9.63184 9.70117H17.0231V17.0925H9.63184V9.70117Z"
                fill="#FFBA08"
            />
        </g>
        <defs>
            <clipPath id="clip0_659_23922">
                <rect
                    width="17"
                    height="17"
                    fill="white"
                    transform="translate(0.762207 0.832031)"
                />
            </clipPath>
        </defs>
    </svg>
</template>
